import { Select } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './LanguageSelector.module.sass';

const options = [
  { value: 'sv', label: 'Svenska' },
  { value: 'en', label: 'English' }
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Select
      value={i18n.language}
      style={{ width: 95 }}
      onChange={changeLanguage}
      className={s.selector}
      options={options}
    />
  );
};

export { LanguageSelector };
export default LanguageSelector;